function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9ub3RpZmljYXRpb24tbmV3LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9ub3RpZmljYXRpb24tbmV3LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBOb3RpZmljYXRpb25OZXcoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHNlY29uZGFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIk5vdGlmaWNhdGlvbiBuZXdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE4IDI0LjVhMiAyIDAgMDEtNCAwek0xNiA2YTEuNSAxLjUgMCAwMTEuNSAxLjV2MS4yMDJjMi42MTkuNzA3IDQuNSAzLjIyIDQuNSA2LjA0OVYyMC41YTEgMSAwIDAwMSAxIDEgMSAwIDExMCAySDlhMSAxIDAgMTEwLTIgMSAxIDAgMDAxLTF2LTZhNS45OTggNS45OTggMCAwMTQuNS01LjgwNVY3LjVBMS41IDEuNSAwIDAxMTYgNnptMCA0LjVhNCA0IDAgMDAtNCA0djdoOHYtN2E0IDQgMCAwMC00LTR6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICAgIDxwYXRoIGQ9XCJNMjQgMTIuNWEzIDMgMCAxMS02IDAgMyAzIDAgMDE2IDBcIiBmaWxsPXtzZWNvbmRhcnlDb2xvcn0gLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuTm90aWZpY2F0aW9uTmV3LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgc2Vjb25kYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTm90aWZpY2F0aW9uTmV3O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function NotificationNew(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Notification new",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M18 24.5a2 2 0 01-4 0zM16 6a1.5 1.5 0 011.5 1.5v1.202c2.619.707 4.5 3.22 4.5 6.049V20.5a1 1 0 001 1 1 1 0 110 2H9a1 1 0 110-2 1 1 0 001-1v-6a5.998 5.998 0 014.5-5.805V7.5A1.5 1.5 0 0116 6zm0 4.5a4 4 0 00-4 4v7h8v-7a4 4 0 00-4-4z",
    fill: primaryColor
  }), ___EmotionJSX("path", {
    d: "M24 12.5a3 3 0 11-6 0 3 3 0 016 0",
    fill: secondaryColor
  }));
}

NotificationNew.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default NotificationNew;